import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeJumpToIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M2.98502 2.86801C2.74902 2.67901 2.40002 2.84701 2.40002 3.14901V20.851C2.40002 21.153 2.74902 21.321 2.98502 21.132L13.814 12.468C14.114 12.228 14.114 11.771 13.814 11.531L2.98502 2.86801Z"
        fill={color}
      />
      <path
        d="M21 2.39999H17.4C17.0686 2.39999 16.8 2.66862 16.8 2.99999V21C16.8 21.3314 17.0686 21.6 17.4 21.6H21C21.3314 21.6 21.6 21.3314 21.6 21V2.99999C21.6 2.66862 21.3314 2.39999 21 2.39999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeJumpToIcon.displayName = 'TimeJumpToIcon';
